export default __webpack_public_path__ + "static/media/Charu.823fe375.jpeg";